<div class="form-content" [formGroup]="serviceForm">
  <!-- Fecha del Servicio Divino -->
  <app-date-picker
    class="form-field full-width"
    label="Fecha del Servicio Divino"
    formControlName="date"
    [errorMessages]="{
      required: 'La fecha es requerida',
      matDatepickerParse: 'Ingresa una fecha valida con formato dd/mm/aaaa.'
    }">
  </app-date-picker>

  <!-- Comunidad -->
  <app-unit-selector [label]="'Comunidad'" [required]="true" [unitSource]="unitSource" [groupByLevel]="true" groupByMode="ancestors" formControlName="organizationUnitId" class="form-field">
  </app-unit-selector>

  <!-- Tipo de Servicio Divino -->
  <mat-form-field class="form-field full-width">
    <mat-label>Tipo de Servicio Divino</mat-label>
    <mat-select formControlName="type" panelClass="wide-select-panel">
      <mat-option *ngFor="let type of serviceTypes" [value]="type.value">
        {{ type.displayName }}
      </mat-option>
    </mat-select>
    <mat-error *ngIf="serviceForm.get('type')?.hasError('required')">
      El tipo de servicio divino es requerido
    </mat-error>
  </mat-form-field>

  <!-- Texto Bíblico -->
  <mat-form-field class="form-field full-width">
    <mat-label>Texto Bíblico</mat-label>
    <input matInput formControlName="bibleText" placeholder="Ej: Juan 3:16">
    <mat-error *ngIf="serviceForm.get('bibleText')?.hasError('required')">
      El texto bíblico es requerido
    </mat-error>
  </mat-form-field>

  <!-- OPTIONAL FIELDS SECTION -->

  <!-- Ofrendas -->
  <app-optional-field 
    [formControls]="[serviceForm.get('offeringsARS')!, serviceForm.get('offeringsUSD')!]"
    triggerLabel="Agregar Ofrendas"
  >
    <section>
      <mat-form-field floatLabel="always">
        <mat-label>Ofrendas (ARS)</mat-label>
        <input matInput type="text" formControlName="offeringsARS" placeholder="0" [currencyMask]="ConfigARS">
        <span matTextPrefix>$&nbsp;</span>
        <mat-error *ngIf="serviceForm.get('offeringsARS')?.hasError('required')">
          El campo de ofrendas ARS es requerido
        </mat-error>
        <mat-error *ngIf="serviceForm.get('offeringsARS')?.hasError('min')">
          El valor debe ser mayor o igual a 0
        </mat-error>
      </mat-form-field>

      <mat-form-field floatLabel="always">
        <mat-label>Ofrendas (USD)</mat-label>
        <input matInput type="text" formControlName="offeringsUSD" placeholder="0" [currencyMask]="ConfigUSD">
        <span matTextPrefix>$&nbsp;</span>
        <mat-error *ngIf="serviceForm.get('offeringsUSD')?.hasError('required')">
          El campo de ofrendas USD es requerido
        </mat-error>
        <mat-error *ngIf="serviceForm.get('offeringsUSD')?.hasError('min')">
          El valor debe ser mayor o igual a 0
        </mat-error>
      </mat-form-field>
    </section>
  </app-optional-field>

  <!-- Siervo Responsable -->
  <app-optional-field 
    [formControls]="serviceForm.get('memberInCharge')!"
    triggerLabel="Agregar Siervo Responsable"
  >
    <mat-form-field class="full-width">
      <mat-label>Siervo Responsable</mat-label>
      <input matInput formControlName="memberInCharge" placeholder="Nombre del siervo responsable">
    </mat-form-field>
  </app-optional-field>

  <!-- Lugar -->
  <app-optional-field 
    [formControls]="serviceForm.get('location')!"
    triggerLabel="Agregar Lugar"
  >
    <mat-form-field class="full-width">
      <mat-label>Lugar</mat-label>
      <input matInput formControlName="location" placeholder="Lugar del servicio">
    </mat-form-field>
  </app-optional-field>

  <!-- Notas -->
  <app-optional-field 
    [formControls]="serviceForm.get('notes')!"
    triggerLabel="Agregar Notas"
  >
    <mat-form-field class="full-width">
      <mat-label>Notas</mat-label>
      <textarea matInput formControlName="notes" placeholder="Notas adicionales" rows="3"></textarea>
    </mat-form-field>
  </app-optional-field>
</div>
